import React from 'react';

import * as S from './AlternateDatesStyle';

const AlternateDatesUI = (props) => {
    const {currentDate,currentDateBusCount,nextDate,nextDateBusCount,onClickCb}  = props;
    return (
        <S.AlternateDates>
            <div>
                <p className="altrntDatesHeading">Travel on next day</p>
                <p className="altrntDatesSubHeading">Buses available on alternate date</p>
            </div>
            <ul>
                <li onClick={onClickCb}>
                     <p>{nextDate}</p>
                    <p>{`${nextDateBusCount} buses`}</p>
                </li>
            </ul>
        </S.AlternateDates>
    );
};

export default AlternateDatesUI;
